import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VMain,[_c('portal',{attrs:{"to":"header"}},[_c(_setup.SettingsHeader)],1),_c(_setup.SettingsBody)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }